import ScheduledCompetencyList from './ScheduledCompetencyList';
export default ScheduledCompetencyList;